import { PortalStatusWordmark } from '@/components/layout/portalStatusPage'

/**
 * Neutral full-screen loading state shown while Firebase is still resolving the initial auth
 * session. It commits to neither the login page nor the dashboard, so a refresh never flashes the
 * sign-in page before bouncing an already-signed-in visitor to the portal (and vice versa).
 */
export function AuthSplash() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-page bg-orange-to-purple-gradient px-6 py-12">
      <div
        className="auth-splash-enter flex flex-col items-center gap-6"
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <PortalStatusWordmark />
        <div className="flex flex-col items-center gap-3">
          <div className="auth-splash-spinner" aria-hidden="true" />
          <p className="text-xs text-muted-foreground">Loading</p>
        </div>
        <span className="sr-only">Loading portal...</span>
      </div>
    </div>
  )
}
